import React, { useEffect } from 'react'
import { ButtonCP } from 'submodules/nerit-framework-ui/common/components/button/ButtonCP'
import { ColumnCP } from 'submodules/nerit-framework-ui/common/components/grid/column/ColumnCP'
import { RowCP } from 'submodules/nerit-framework-ui/common/components/grid/row/RowCP'
import { DateRangePickerCP } from 'submodules/nerit-framework-ui/common/components/form-fields/date-range-picker/DateRangePickerCP'
import { IFormStateManager } from 'submodules/nerit-framework-ui/common/form-state-manager/types/IFormStateManager'
import { WrapperFiltersCP } from 'submodules/nerit-framework-ui/features/common/components/filters/wrapper-filters/WrapperFiltersCP'
import { useRequest } from 'submodules/nerit-framework-ui/common/request-manager/use-request/UseRequest'
import { RequestUtils } from 'submodules/nerit-framework-utils/sdk-utils/request-manager/RequestUtils'
import { NotificationHelper } from 'submodules/nerit-framework-ui/common/components/notification/inner/NotificationHelper'
import { ListResponseDTO } from 'submodules/nerit-framework-utils/sdk-utils/dtos/response/ListResponseDTO'
import { NameAndCodeResponseDTO } from 'submodules/nerit-framework-utils/sdk-utils/dtos/response/NameAndCodeResponseDTO'
import { MatrixRequests } from 'submodules/nerit-aquatec-sdk/services/matrix/MatrixRequests'
import { SelectLocationCP } from 'common/components/form/SelectLocationCP'
import { SelectMatrixCP } from 'modules/collection-performance/components/selects/select-matrix/SelectMatrixCP'
import { CollectionControlFiltersFormModel } from 'modules/collection-performance/components/collection-control/filters-collection-control/inner/CollectionControlFiltersFormModel'

interface ICPProps {
    formStateManager: IFormStateManager<CollectionControlFiltersFormModel>
    onFilter: () => void
    isLoading?: boolean
}

/**
 * Filtros do Controle de Pontos (Tela 3.2). Ao escolher uma Matriz, o filtro de
 * pontos e preenchido com os pontos daquela matriz (a Matriz funciona como Campanha).
 * No periodo o usuario escolhe datas, mas apenas mes e ano sao considerados.
 */
export function FiltersCollectionControlCP(props: ICPProps): JSX.Element {

    const matrixLocationsRequest = useRequest<ListResponseDTO<NameAndCodeResponseDTO>>()
    useEffect(onMatrixLocationsRequestChange, [matrixLocationsRequest.isAwaiting])

    /**
     */
    function onChangeMatrix(matrixCode?: number): void {
        if (!matrixCode)
            return

        matrixLocationsRequest.runRequest(MatrixRequests.getLocations(matrixCode))
    }

    /**
     */
    function onMatrixLocationsRequestChange(): void {

        if (!RequestUtils.isValidRequestReturn(matrixLocationsRequest, NotificationHelper.DEFAULT_ERROR_GET_MESSAGE))
            return

        const locations = matrixLocationsRequest.responseData?.list ?? []
        props.formStateManager.changeFieldValue('locationCodes', locations.map((location) => location.code))
    }

    return (
        <WrapperFiltersCP
            filters={
                <RowCP>
                    <ColumnCP size={6}>
                        <SelectMatrixCP
                            formStateManager={props.formStateManager}
                            fieldName={'matrixCode'}
                            onChange={onChangeMatrix}
                        />
                    </ColumnCP>
                    <ColumnCP size={8}>
                        <SelectLocationCP
                            isMany={true}
                            formStateManager={props.formStateManager}
                            fieldName={'locationCodes'}
                            isRequired={true}
                            maxTagCount={2}
                        />
                    </ColumnCP>
                    <ColumnCP size={6}>
                        <DateRangePickerCP
                            label={'Período'}
                            showBorder={true}
                            fastFilter={'all'}
                            fieldName={'dateRange'}
                            formStateManager={props.formStateManager}
                        />
                    </ColumnCP>
                </RowCP>
            }
            filterButton={
                <ButtonCP
                    icon={'search'}
                    type={'primary'}
                    onClick={props.onFilter}
                    loading={props.isLoading}
                />
            }
        />
    )
}
